import React from 'react';

/**
 * Component to render FillInTheBlank sentence with blanks
 */
export function FillInTheBlankSentence({ parts, showAnswers = false, userAnswersByBlankId = {} }) {
  if (!parts) return null;

  return (
    <div className="text-base leading-[1.8] mb-6 p-4 rounded-lg bg-[var(--bg-tertiary)]">
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return <span key={index} className="text-[var(--text-primary)]">{part.content}</span>;
        }
        
        const blankId = part.blank.id || part.blankIndex;
        const correctAnswerText = part.blank.correctAnswer || '';
        
        if (showAnswers) {
          const userAnswerData = userAnswersByBlankId[blankId];
          const userAnswerText = userAnswerData?.text || '';
          
          return (
            <span key={index}>
              {userAnswerText ? (
                <div className="inline-block px-3 py-2 rounded-full border border-gray-300 dark:border-slate-600 bg-gray-50 dark:bg-slate-900 shadow-sm mx-1">
                  <span className="text-sm font-medium text-gray-800 dark:text-slate-200">
                      {userAnswerText}
                    </span>
                </div>
              ) : (
                <span className="inline-block mx-1 border-b-2 border-gray-400 dark:border-slate-500 min-w-[60px] h-6"></span>
              )}
            </span>
          );
        }
        
        // Show correct answer
        return (
          <span key={index}>
            <div className="inline-block px-3 py-2 rounded-full border border-green-300 bg-green-50 shadow-sm mx-1">
              <span className="text-sm font-medium text-green-800">{correctAnswerText}</span>
            </div>
          </span>
        );
      })}
    </div>
  );
}

/**
 * Component to render question text with blanks as underlines
 */
export function FillInTheBlankQuestionText({ parts, fallbackText }) {
  if (parts) {
    return (
      <div className="mb-6">
        <p className="text-base leading-relaxed text-[var(--text-primary)]">
          {parts.map((part, index) => {
            if (part.type === 'text') {
              return <span key={index}>{part.content}</span>;
            }
            return <span key={index} className="inline-block mx-1 border-b-2 border-gray-400 dark:border-slate-500 min-w-[60px] h-6"></span>;
          })}
        </p>
      </div>
    );
  }
  
  return <p className="text-base leading-relaxed text-[var(--text-primary)]">{fallbackText || ''}</p>;
}

